import { render, staticRenderFns } from "./LiveStatisticsView.vue?vue&type=template&id=3f6d71fb&scoped=true"
import script from "./LiveStatisticsView.vue?vue&type=script&lang=js"
export * from "./LiveStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d71fb",
  null
  
)

export default component.exports